<template>
<div style="padding: 5px;">
    <div class="card">    
        <loading :active.sync="isLoading" 
            :can-cancel="false" 
            :is-full-page="true">
        </loading>
        <div class="card-header">
            <p class="card-header-title">Add a Group</p>
        </div>
    </div>
    <div style="padding: 5px;">
        <div class="columns">
            <div class="column is-3">
                <input class="input is-success" type="text" placeholder="Group Name" v-model="name">
            </div>
            <div class="column is-4">
                <multiselect v-model="teachers" :options="listTeachers" :close-on-select="false" :multiple="true" :hide-selected="true" label="firstName" track-by="firstName" placeholder="Appoint teachers/supervisors"></multiselect>
            </div>
            <div class="column is-2 vertical-center">
                <b-radio v-model="status" native-value="1" checked>
                    Active
                </b-radio>
                <b-radio v-model="status" native-value="0">
                    Inactive
                </b-radio>
            </div>
            <div class="column is-3">
                <button class='button is-primary  is-fullwidth' v-on:click="sendForm()" >Create</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "ManageGroupAdd",
    components:{
        Multiselect,
        Loading,
    },
    data() {
        return {
            listTeachers: [{
                _id: '',
                firstName: ''
            }],
            name: '',
            teachers: [],
            status: 1,
            isLoading: false,
        };
    },
    created() {
        this.getTeacherList();
    },
    methods: {
        getTeacherList(){
            let self = this;            
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/teachers/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                self.listTeachers = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        sendForm() {
            let self = this;

            var name = self.name;
            var teachers = self.teachers;
            var status = self.status;

            if (name.length < 1){
                Toast.open({
                    message: "Please enter the group name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (status){
                status = parseInt(status)
            }else{
                status = 0
            }

            this.$emit('create-group', {
                name
            });

            self.isLoading = true;

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/groups/add', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                name: name,
                teachers: teachers,
                status: status                
            })
            .then(response => {
                self.isLoading = false;
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }

                self.name = ""
                self.teachers = []
                self.status = 1
                this.$parent.getData()
            })
            .catch(e => {
                self.isLoading = false;
                console.log(e.response)
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
         
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.vertical-center{
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/Groups/AddContent.vue